<template>
  <a-form-model
    :model="value"
    layout="inline"
    class="form-content"
  >
    <a-row>
      <a-col :span="5">
        <a-form-model-item
          label="线路"
          :colon="false"
          class="form-item"
        >
          <a-input
            v-model="value.lineName"
            class="w-224"
            placeholder="请输入线路名称"
            :max-length="100"
            @pressEnter="toSearch"
          />
        </a-form-model-item>
      </a-col>
      <!-- <a-col :span="6">
        <a-form-model-item
          label="仓库"
          :colon="false"
          class="form-item"
        >
          <a-input
            v-model="value.warehouse"
            class="w-224"
            placeholder="请输入始发仓或者目的仓"
            :max-length="100"
            @pressEnter="toSearch"
          />
        </a-form-model-item>
      </a-col> -->
      <a-col :span="5">
        <a-form-model-item
          label="始发仓"
          :colon="false"
          class="form-item"
        >
          <a-input
            v-model="value.startWarehouse"
            class="w-224"
            placeholder="请输入始发仓"
            :max-length="50"
            @pressEnter="toSearch"
          />
        </a-form-model-item>
      </a-col>
      <a-col :span="5">
        <a-form-model-item
          label="目的仓"
          :colon="false"
          class="form-item"
        >
          <a-input
            v-model="value.endWarehouse"
            class="w-224"
            placeholder="请输入目的仓"
            :max-length="50"
            @pressEnter="toSearch"
          />
        </a-form-model-item>
      </a-col>

      <a-col :span="5">
        <a-form-model-item
          label="车型"
          :colon="false"
          class="form-item"
        >
          <a-select
            v-model="value.truckType"
            placeholder="请选择车型"
            allow-clear
            @change="toSearch"
          >
            <a-select-option v-for="item in CARTYPELIST" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-col>
      <a-col :span="4" class="form-btns">
        <a-button class="reset-btn" @click="onReset">重置</a-button>
        <a-button type="primary" @click="toSearch">
          查询
        </a-button>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { CARTYPELIST } from '../const'

export default {
  name: 'LineSearch',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      CARTYPELIST
    }
  },
  methods: {
    toSearch() {
      this.$emit('toSearch')
    },
    onReset() {
      this.$emit('onReset')
    }
  }
}
</script>
<style lang="less" scoped>
.form-content {
  .form-btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
    .reset-btn {
      margin-right: 8px;
    }
  }
  .form-item {
    width: 100%;
    /deep/.ant-form-item-control-wrapper {
      width: calc(100% - 102px);
      margin-right: 32px;
    }
  }
}
</style>
